import { render, staticRenderFns } from "./EmployeeCardName.vue?vue&type=template&id=52c5630a"
import script from "./EmployeeCardName.vue?vue&type=script&lang=ts"
export * from "./EmployeeCardName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c5630a')) {
      api.createRecord('52c5630a', component.options)
    } else {
      api.reload('52c5630a', component.options)
    }
    module.hot.accept("./EmployeeCardName.vue?vue&type=template&id=52c5630a", function () {
      api.rerender('52c5630a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeCardName.vue"
export default component.exports